import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AIConfig } from "@graylog/enterprise-api";
import UserNotification from "util/UserNotification";
import { AI_CONFIGURATION_QUERY_STRING } from "ai/hooks/useAIConfiguration";
const enableAI = () => AIConfig.enableAI();
const disableAI = () => AIConfig.disableAI();
const useAIConfigurationMutations = () => {
  const queryClient = useQueryClient();
  const { mutateAsync: enable } = useMutation({
    mutationFn: enableAI,
    onSuccess: () => {
      UserNotification.success("Configuration updated successfully.");
      queryClient.invalidateQueries({
        queryKey: [AI_CONFIGURATION_QUERY_STRING]
      });
    },
    onError: (error) => {
      UserNotification.error(`Configuration update failed with error: ${error}.`);
    }
  });
  const { mutateAsync: disable } = useMutation({
    mutationFn: disableAI,
    onSuccess: () => {
      UserNotification.success("Configuration updated successfully.");
      queryClient.invalidateQueries({
        queryKey: [AI_CONFIGURATION_QUERY_STRING]
      });
    },
    onError: (error) => {
      UserNotification.error(`Configuration update failed with error: ${error}.`);
    }
  });
  return {
    enable,
    disable
  };
};
export default useAIConfigurationMutations;
